<!--
 * @version: V1.0.0
 * @Date: 2023-11-01 16:03:16
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-05 15:27:25
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\components\conditionSearch\index.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <div style="height: 40px">
    <el-form ref="queryForm"  :model="searchParam" inline class="search-form" >
      <el-form-item  v-for="query in queryItems" :key="query.field" :label="query.label" :prop="queryItems.field">
        <el-input v-if="query.type === 'input'" v-model="searchParam[query.field]"
                  :style="{ width: query.width || '200px' }" :placeholder="query.placeholder || '请输入'" clearable
                  @change="$emit('search')"></el-input>
        <el-date-picker v-else-if="query.type === 'date'" v-model="searchParam[query.field]" type="daterange"
                        range-separator="-" start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="结束日期" @change="$emit('search')"></el-date-picker>
        <el-select v-else-if="query.type === 'select'" v-model="searchParam[query.field]" clearable
                   @change="$emit('search')">
          <el-option v-for="item in query.options" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
          </el-option>
        </el-select>
        <el-cascader v-else-if="query.type === 'cascader'" v-model="searchParam[query.field]"
                     :props="{ checkStrictly: true }" :options="query.options" @change="$emit('search')" />

      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="$emit('search')">搜索</el-button>
        <el-button size="small" @click="$emit('reset')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'ConditionSearch',
  components: {},
  props: {
    queryItems: {
      type: Array,
      default() {
        return []
      }
    },
    searchParam: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    //这里存放数据
    return {

    };
  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>
